'use strict';

/**
 *
 * @name: apiPicksService
 *
 */

function ApiPicksService(
  $http,
  $rootScope,
  transObject,
  translateDate
) {

  'ngInject';

  /**
   *
   * @PUBLIC
   *
   */

  var hostObject = {
    getPicks: getPicks,
    sort: 'publishDate desc'
  };

  function getPicks(chronology, slug) {

    var sort = hostObject.sort || 'publishDate desc';

    if (chronology === 'isAfter') {
      sort = sort.replace('desc', 'asc');
    }

    var target = $rootScope.apiUrlNew + '/post?isPublished=true&nownessPicks=true' +
      '&order=' + sort +
      '&page=1' +
      '&limit=12' +
      (chronology ? '&' + chronology + '=' + slug : '');


    return $http.get(target)
      .success(function(data) {

        if (chronology === 'isAfter') {

          data.items.reverse();
        }

        data.items.forEach(function(item) {

          transObject.translate(item);
          transObject.setBookmark(item);
          transObject.calendarDate(item);
          transObject.translate(item.category);
          transObject.getDuration(item);

          if (item.tags && item.tags.length) {

            item.tags.forEach(function(tag) {

              transObject.translate(tag);
            });
          }

          transObject.myAss(item);

          if (item.contributors && item.contributors.length) {

            item.contributors.forEach(function(contributor) {

              transObject.trueSlug(contributor);
            });
          }

          item.publishDate = translateDate(item.publishDate);
          item.publishedAt = translateDate(item.publishedAt);
        });
      });
  }

  /**
   *
   * @PRIVATE
   *
   */

  return hostObject;
}

export default ApiPicksService;



// WEBPACK FOOTER //
// ./app/components/_api/picks.service.js